export enum ImageSize {
  SMALL = "small",
  LARGE = "large",
}
